import { network, signupNetwork } from './types';

const basePath = ['networkSignup', 'network'];
const baseSignupPath = ['networkSignup', 'signup'];

const marketplaceReducerObject = {
  [network.request]: (state) =>
    state
      .setIn([...basePath, 'network', 'error'], false)
      .setIn([...basePath, 'network', 'loading'], true)
      .setIn([...basePath, 'network', 'success'], false)
      .setIn([...basePath, 'data'], null),
  [network.success]: (state, action) =>
    state.withMutations((currentState) =>
      currentState
        .setIn([...basePath, 'network', 'loading'], false)
        .setIn([...basePath, 'network', 'error'], false)
        .setIn([...basePath, 'network', 'success'], true)
        .setIn([...basePath, 'data'], action.response),
    ),
  [network.failure]: (state, action) =>
    state.withMutations((currentState) =>
      currentState
        .setIn([...basePath, 'network', 'loading'], false)
        .setIn([...basePath, 'network', 'error'], action.error)
        .setIn([...basePath, 'network', 'success'], false),
    ),
  [signupNetwork.request]: (state) =>
    state
      .setIn([...baseSignupPath, 'network', 'error'], false)
      .setIn([...baseSignupPath, 'network', 'loading'], true)
      .setIn([...baseSignupPath, 'network', 'success'], false),
  [signupNetwork.success]: (state) =>
    state
      .setIn([...baseSignupPath, 'network', 'loading'], false)
      .setIn([...baseSignupPath, 'network', 'error'], false)
      .setIn([...baseSignupPath, 'network', 'success'], true),
  [signupNetwork.failure]: (state, action) =>
    state.withMutations((currentState) =>
      currentState
        .setIn([...baseSignupPath, 'network', 'loading'], false)
        .setIn([...baseSignupPath, 'network', 'error'], action.error)
        .setIn([...baseSignupPath, 'network', 'success'], false),
    ),
};

export default marketplaceReducerObject;
